import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_214: DocMigration = {
  maxSchemaVersion: "0.0.214",
  description: "Rename salesView to showroom in any places it shows up.",
  apply(json: any) {
    if (json.railings) {
      for (const railingId in json.railings) {
        const railing = json.railings[railingId];

        if (railing?.addToSalesViewPlan !== undefined) {
          railing.addToShowroomPlan = railing.addToSalesViewPlan;
          delete railing.addToSalesViewPlan;
        }
      }
    }

    if (json.viewerFilter?.annotationSalesViewPlan !== undefined) {
      json.viewerFilter.annotationShowroomPlan = json.viewerFilter.annotationSalesViewPlan;
      delete json.viewerFilter.annotationSalesViewPlan;
    }

    if (json.annotation) {
      for (const annotationId in json.annotation) {
        const anno = json.annotation[annotationId];

        if (anno?.addToSalesViewPlan !== undefined) {
          anno.addToShowroomPlan = anno.addToSalesViewPlan;
          delete anno.addToSalesViewPlan;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_214;
